<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-alert
          v-if="updateSuccess"
          dense
          type="success"
          outlined
          text
          dismissible
          transition="slide-x-transition"
          class="py-0 text-uppercase"
        >
          Stock Successfully Updated!!!
        </v-alert>
        <v-alert
          v-for="(item, index) in updateErrors"
          :key="index"
          dense
          type="error"
          outlined
          text
          dismissible
          transition="slide-x-transition"
          class="py-0 text-uppercase"
        >
          {{ item[0] }}
        </v-alert>
      </v-col>
      <v-col
        cols="4"
      >
        <v-text-field
          v-model="stockCode"
          disabled
        />
        <!-- <v-autocomplete
          v-model="supplierProductId"
          label="Stock Code"
          :items="supplierProducts"
          item-value="id"
        >
          <template v-slot:selection="{ item }">
            {{ item.supplier_id }}{{  item.stock_id  }}
          </template>
          <template v-slot:item="{ item }">
            <span class="blue--text">{{ item.stock_id }}</span>
            <span class="mx-1"></span>
            <small>{{ item.stock.product_name }} ({{ item.stock.brand_name }})</small>
          </template>
        </v-autocomplete> -->
      </v-col>
      <v-col
        cols="8"
        align-self="end"
      >
        <v-text-field
          label="Product Name"
          :value="productName"
          disabled
        />
      </v-col>
      <v-col
        cols="6"
        align-self="end"
      >
        <v-text-field
          label="Brand"
          :value="brandName"
          disabled
        />
      </v-col>
      <v-col
        cols="6"
        align-self="end"
      >
        <v-text-field
          v-model="cost"
          label="Cost"
          required
          :suffix="`/ ${unit}`"
          prefix="₱"
          :disabled="supplierProductId === null"
          type="number"
        />
      </v-col>
      <v-col cols="3">
        <v-btn
          block
          color="green"
          :loading="updating"
          @click="initUpdate"
        >
          Save
        </v-btn>
      </v-col>
      <v-col cols="3">
        <v-btn
          v-if="stockCode"
          block
          color="red"
          @click="clearInputs"
        >
          Cancel
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapState, mapActions } from 'vuex'

  function inputVars () {
    return {
      stockCode: null,
      supplierProductId: null,
      brandName: null,
      unit: null,
      retail: null,
      productName: null,
      cost: null,
    }
  }
  export default {
    name: 'VEditSupplierProduct',
    data () {
      return {
        ...inputVars(),
      }
    },
    computed: {
      ...mapState({
        stocks: state => state.stock.list,
        updateErrors: state => state.supplierProduct.updateErrors,
        updating: state => state.supplierProduct.updating,
        updateSuccess: state => state.supplierProduct.updateSuccess,
      }),
    },
    watch: {
    },
    methods: {
      ...mapActions({
        update: 'supplierProduct/update',
      }),
      populateVars (data) {
        this.supplierProductId = data.id
        this.brandName = data.brand_name
        this.description = data.description
        this.stockCode = data.stock_code
        this.cost = data.cost
        this.productName = data.product_name
        this.unit = data.unit
      },
      initUpdate () {
        const data = {
          cost: this.cost,
        }
        this.update({ id: this.supplierProductId, data })
      },
      clearInputs () {
        Object.keys(inputVars()).forEach(key => {
          this[key] = null
        })
      },
    },
  }
</script>
